export const documentReviewStages = [
  {
    id: 'chunking', label: 'Chunking', input: 'document', output: 'chunks',
    inputLabel: 'Report structure', outputLabel: 'Bounded reading tasks',
    caption: 'Related pages are grouped into manageable chunks for the model to read.',
  },
  {
    id: 'rendering', label: 'Page rendering', input: 'chunks', output: 'pages',
    inputLabel: 'Report chunks', outputLabel: 'Page images',
    caption: 'Rendering preserves the layout of text, tables and figures for the vision-language model.',
  },
  {
    id: 'extraction', label: 'Evidence extraction', input: 'pages', output: 'records',
    inputLabel: 'Every source page', outputLabel: 'Shared evidence ledger',
    caption: 'Extraction creates individual observations that retain their context and source references.',
  },
  {
    id: 'synthesis', label: 'Synthesis', input: 'records', output: 'assessment',
    inputLabel: 'Relevant evidence records', outputLabel: 'Assessment for each risk',
    caption: 'Synthesis applies the decision rules and combines the evidence into a finding and its reasoning.',
  },
  {
    id: 'presentation', label: 'Review interface', input: 'assessment', output: 'workspace',
    inputLabel: 'Findings and references', outputLabel: 'Review workspace',
    caption: 'The interface presents each finding beside its evidence and source pages, ready for a reviewer’s decision.',
  },
];
